import React from 'react'
import './SectionWithLabel.scss' // Make sure to import the CSS file

const SectionWithLabel = ({ label, deleteButton, children }) => {
  return (
    <div className="section">
      <div className="section-label">
        {label}
        {deleteButton && <span className="delete-icon">{deleteButton}</span>}
      </div>
      <div className="section-content">{children}</div>
    </div>
  )
}

export default SectionWithLabel
